export default function SupportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10H16C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10H6C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10ZM4 12.0001C4 10.8955 4.89542 10.0001 5.99999 10.0001L8 10.0001V14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14V12.0001ZM9.68721 10.0001L8 10.0001V10C7.54338 10 8.05327 10 9.02962 10C9.23052 10 9.45116 10.0001 9.68721 10.0001ZM16 10.0002C14.3597 10.0002 11.5461 10.0001 9.68721 10.0001L18 10C19.1046 10 20 10.8954 20 12V14C20 15.1046 19.1046 16 18 16C18 18.206 16.206 20 14 20H10V17H14V18C15.103 18 16 17.103 16 16V10.0002Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
